'use client';

import { Button } from '@ahafood/ui/components/button';
import { cn } from '@ahm/common-helpers';
import { ClipboardClock, House } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React, { useState } from 'react';
import { useNavigation } from './navigation-context';
import AmoriContainer from '@/app/[locale]/amori/amori-container';
import { CITIES, useAiFoodOrderStore } from '@/store';

export function Navigation() {
  const [isOpen, setOpenChange] = useState(false);
  const pathname = usePathname();
  const cityId = useAiFoodOrderStore.use.city_id();
  const citySlug = CITIES.find((c) => c.value === cityId)?.slug ?? 'da-nang';
  const { isNavigationVisible } = useNavigation();

  const handleToggleAmori = () => {
    setOpenChange(!isOpen);
  };

  const navigationItems = [
    {
      key: 'home',
      href: `/${citySlug}`,
      icon: House,
      label: 'Trang chủ',
    },
    {
      key: 'orders',
      href: `/order-list`,
      icon: ClipboardClock,
      label: 'Đơn hàng',
    },
  ];
  return (
    <>
      <nav
        className={cn(
          'fixed bottom-0 inset-x-0 z-[9999] bg-white border-t border-neutral-20 px-4 py-1 safe-area-pb transition-transform duration-300 ease-in-out',
          !isNavigationVisible && 'translate-y-full'
        )}
      >
        <div className="flex justify-around items-center max-w-md mx-auto">
          {navigationItems.map((item) => {
            // Cast Icon for JSX compatibility
            const Icon = item.icon as React.ComponentType<any>;
            const isActive = pathname === item.href;

            return (
              <Link
                key={item.key}
                href={item.href}
                className={cn(
                  'flex flex-col items-center justify-center px-3 py-2 min-w-[110px] rounded-lg transition-colors',
                  isActive
                    ? 'text-primary-50'
                    : 'text-neutral-50 hover:text-neutral-70'
                )}
                onClick={() => {
                  setOpenChange(false);
                }}
              >
                {/* {item.icon === 'custom' && item.customIcon ? (
                  <div className=" size-7 relative overflow-hidden rounded-sm">
                    <Image
                      src={item.customIcon || '/placeholder.svg'}
                      alt={item.label}
                      fill
                      className="object-cover"
                    />
                  </div>
                ) : ( */}
                <Icon size={24} className={cn('mb-1')} />
                {/* )} */}
                <span
                  className={cn(
                    'text-xs',
                    isActive ? 'text-primary-50 font-bold' : 'text-neutral-60'
                  )}
                >
                  {item.label}
                </span>
              </Link>
            );
          })}
          <Button
            className="bg-gradient-to-r from-[#305B8D] via-[#F879FD] to-primary-50 text-transparent bg-clip-text font-bold min-w-[110px] items-center flex flex-col h-full gap-0 py-1"
            onClick={() => {
              handleToggleAmori();
            }}
          >
            <div className=" size-7 relative overflow-hidden rounded-sm">
              <Image
                src="/static/images/amori-nav-avt.webp"
                alt={'Amori tìm món'}
                fill
                className="object-cover"
              />
            </div>
            Amori
          </Button>
        </div>
      </nav>
      <AmoriContainer isOpen={isOpen} setOpenChange={setOpenChange} />
    </>
  );
}
